import { render, staticRenderFns } from "./AIPanel.vue?vue&type=template&id=04980efb&scoped=true"
import script from "./AIPanel.vue?vue&type=script&lang=js"
export * from "./AIPanel.vue?vue&type=script&lang=js"
import style0 from "./AIPanel.vue?vue&type=style&index=0&id=04980efb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04980efb",
  null
  
)

export default component.exports